import React, { useState } from 'react';
import profpic from './assets/profile-pic.png';
import './App.scss';
import { Routes, Route, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedinIn, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons';
import About from './pages/About';
import Projects from './pages/Projects';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import BlogPreview from './pages/BlogPreview';
import { AppBar, Avatar, Box, Button, Container, Toolbar, Typography, IconButton, Paper, Drawer, List, ListItem, Divider, ListItemIcon, ListItemText, ListItemButton } from '@mui/material';
import { Menu, FileOpen, LibraryBooks, Construction } from '@mui/icons-material';


const App: React.FC = () => {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen)
  };

  const openSocialMedia = (socialMediaLink: string) => {
    setDrawerOpen(false);
    setTimeout(() => {
      window.open(socialMediaLink, '_blank');
    }, 350);
  };
  const fbUrl = "https://facebook.com/feldmanleo";
  const linkedInUrl = "https://linkedin.com/in/leoafeldman";
  const githubUrl = "https://github.com/EmperorLeo";
  const instaUrl = "https://www.instagram.com/leonitusaf";

  return (
    <Box>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ gap: '1em', justifyContent: 'flex-end', display: { xs: 'none', md: 'flex' } }}>
            <Toolbar disableGutters sx={{ alignSelf: 'flex-start', marginRight: 'auto', gap: '1em' }}>
              <Avatar alt="Leo Feldman" src={profpic} />
              <Typography>feldman.dev</Typography>
            </Toolbar>
            <NavLink to={'/'}><Button variant="contained" color="primary">About</Button></NavLink>
            <NavLink to={'/projects'}><Button variant="contained" color="primary">Projects</Button></NavLink>
            <NavLink to={'/blogs'}><Button variant="contained" color="primary">Blogs</Button></NavLink>
            <Box color="secondary">
              <Paper variant="outlined">
                <IconButton color="secondary"><a href={fbUrl} target="_blank" rel="external noopener noreferrer"><FontAwesomeIcon icon={faFacebook} /></a></IconButton>
                <IconButton color="secondary"><a href={linkedInUrl} target="_blank" rel="external noopener noreferrer"><FontAwesomeIcon className="free" icon={faLinkedinIn} /></a></IconButton>
                <IconButton color="secondary"><a href={githubUrl} target="_blank" rel="external noopener noreferrer"><FontAwesomeIcon icon={faGithub} /></a></IconButton>
                <IconButton color="secondary"><a href={instaUrl} target="_blank" rel="external noopener noreferrer"><FontAwesomeIcon className="free" icon={faInstagram} /></a></IconButton>
              </Paper>
            </Box>
          </Toolbar>
          <Toolbar disableGutters sx={{ justifyContent: 'flex-end', display: { md: 'none' } }}>
            <IconButton onClick={toggleDrawer} size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 'auto' }}>
              <Menu />
            </IconButton>
            <Avatar alt="Leo Feldman" src={profpic} />
            <Typography sx={{ ml: '1em' }}>feldman.dev</Typography>
          </Toolbar>
        </Container>
      </AppBar>
      {/* A flat 2em costs 64px of a 393px phone screen; scale it by breakpoint
          so mobile content gets that width back. */}
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 4 }, py: { xs: 3, sm: 4 } }}>
        <Routes>
          <Route path="/" element={<About />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/blogs/:id' element={<BlogDetail />} />
          <Route path='/preview/:slug' element={<BlogPreview />} />
        </Routes>
      </Container>
      <Drawer anchor='left' open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box>
          <List>
            <ListItem sx={{ pl: "2em", pr: "2em" }}>
              <Typography variant="h6">feldman.dev</Typography>
            </ListItem>
          </List>
          <Divider />
          <List>
            <NavLink to={'/'}>
              <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => setDrawerOpen(false)}>
                <ListItemIcon>
                  <FileOpen />
                </ListItemIcon>
                <ListItemText primary="About" />
              </ListItemButton>
            </NavLink>
            <NavLink to={'/projects'}>
              <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => setDrawerOpen(false)}>
                <ListItemIcon>
                  <Construction />
                </ListItemIcon>
                <ListItemText primary="Projects" />
              </ListItemButton>
            </NavLink>
            <NavLink to={'/blogs'}>
              <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => setDrawerOpen(false)}>
                <ListItemIcon>
                  <LibraryBooks />
                </ListItemIcon>
                <ListItemText primary="Blogs" />
              </ListItemButton>
            </NavLink>
          </List>
          <Divider />
          <List>
            <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => openSocialMedia(fbUrl)}>
              <ListItemIcon>
                <FontAwesomeIcon size='lg' icon={faFacebook} />
              </ListItemIcon>
              <ListItemText primary="Facebook" />
            </ListItemButton>
            <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => openSocialMedia(instaUrl)}>
              <ListItemIcon>
                <FontAwesomeIcon size='lg' icon={faInstagram} />
              </ListItemIcon>
              <ListItemText primary="Instagram" />
            </ListItemButton>
            <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => openSocialMedia(githubUrl)}>
              <ListItemIcon>
                <FontAwesomeIcon size='lg' icon={faGithub} />
              </ListItemIcon>
              <ListItemText primary="Github" />
            </ListItemButton>
            <ListItemButton sx={{ pl: "2em", pr: "2em" }} onClick={() => openSocialMedia(linkedInUrl)}>
              <ListItemIcon>
                <FontAwesomeIcon size='lg' icon={faLinkedinIn} />
              </ListItemIcon>
              <ListItemText primary="LinkedIn" />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default App;
